import React, {Component} from 'react'

export default class ChatWidget extends Component {
  constructor(props) {
    super(props)
    this.widgets = {
      report: {
        url: '',
        message: ''
      },
      default: {
        url: '',
        message: ''
      }
    }
    this.state = {
      chatDisplayed: true,
      widget: 'default'
    }
  }

  componentDidMount() {
    if(!this.state.chatDisplayed) {
      const widget = new window.LandbotLivechat({
        index: this.widgets['default'].url,
      })
      window.widget = widget
      setTimeout(() => {
        widget.sendProactive(this.widgets['default'].message);
      }, 8000);
    }
  }

  render() {
    if(/\/getyourscore\/report\/act_/.test(window.location.hash) && window.widget) {
      window.widget.config.index = this.widgets['report'].url
      setTimeout(() => {
        window.widget.sendProactive(this.widgets['report'].message)
      }, 2000);

    }
    return (<i></i>)
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatWidget.js